export const SHOW_PROCESS_STATEMENT_COMMENTS_FAILURE = 'SHOW_PROCESS_STATEMENT_COMMENTS_FAILURE';

export const showProcessStatementCommentsFailure = error => ({
    type: SHOW_PROCESS_STATEMENT_COMMENTS_FAILURE,
    payload: error,
    error: true,
});
